import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';
import Arrow from '@/assets/icons/filledDownArrow.svg?react';

export const NAME_CELL_WIDTH = '350px';
export const TYPE_CELL_WIDTH = '160px';
export const PARTICIPANTS_CELL_WIDTH = '600px';

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px 0 0;
  height: 48px;
  margin: 16px 0 0 16px;
`;

export const LeftColumnsCont = styled.div`
  width: 100%;
  display: flex;
  margin-left: 64px;
`;

export const Column = styled(LabelRegularBoldM)`
  letter-spacing: 0.08em;
  text-transform: uppercase;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const NameColumn = styled(Column)`
  display: flex;
  align-items: center;
  width: ${NAME_CELL_WIDTH};
  justify-self: flex-start;
`;
export const TypeColumn = styled(Column)`
  width: ${TYPE_CELL_WIDTH};
`;
export const ParticipantsColumn = styled(Column)<{ isEffectSurvey: boolean }>`
  width: ${({ isEffectSurvey }) => (isEffectSurvey ? PARTICIPANTS_CELL_WIDTH : 'auto')};
  margin-left: ${({ isEffectSurvey }) => (isEffectSurvey ? '29px' : '0')};
`;

export const ArrowsCont = styled.span`
  display: flex;
  margin: 0 0 0 1rem;
  flex-flow: column nowrap;
  justify-content: center;
  cursor: pointer;
`;

interface IArrowIcon extends IThemeProvider {
  isActive: boolean;
}

export const ArrowDownIcon = styled(Arrow)`
  width: 8px;
  margin: 0.2rem;

  ${({ theme, isActive }: IArrowIcon) => `
    path {
      fill: ${isActive ? theme.colors.neutral.primary[100] : theme.colors.neutral.primary[40]};
    }
  `}
`;

export const ArrowUpIcon = styled(Arrow)`
  width: 8px;
  margin: 0.2rem;
  transform: rotate(180deg);

  ${({ theme, isActive }: IArrowIcon) => `
    path {
      fill: ${isActive ? theme.colors.neutral.primary[100] : theme.colors.neutral.primary[40]};
    }
  `}
`;
